import { ShaderDataType } from "../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../layagl/LayaGL";
export class ShaderDefines2D {
    static _buildDefineMap() {
        this._perElementDefineMap = [];
        const defines = [
            ShaderDefines2D.FILLTEXTURE, ShaderDefines2D.GAMMATEXTURE, ShaderDefines2D.VERTEXALPHA,
            ShaderDefines2D.TEXTURESHADER, ShaderDefines2D.PRIMITIVESHADER, ShaderDefines2D.USE_TEX_ARRAY,
            ShaderDefines2D.MATERIALCLIP, ShaderDefines2D.UNIFORMCLIP, ShaderDefines2D.UV_CLIP_GPU,
            ShaderDefines2D.VERTEX_SIZE
        ];
        const bits = [
            ShaderDefines2D.DEFINE_BIT_FILLTEXTURE, ShaderDefines2D.DEFINE_BIT_GAMMATEXTURE, ShaderDefines2D.DEFINE_BIT_VERTEXALPHA,
            ShaderDefines2D.DEFINE_BIT_TEXTURESHADER, ShaderDefines2D.DEFINE_BIT_PRIMITIVESHADER, ShaderDefines2D.DEFINE_BIT_USE_TEX_ARRAY,
            ShaderDefines2D.DEFINE_BIT_MATERIALCLIP, ShaderDefines2D.DEFINE_BIT_UNIFORMCLIP, ShaderDefines2D.DEFINE_BIT_UV_CLIP_GPU,
            ShaderDefines2D.DEFINE_BIT_VERTEX_SIZE
        ];
        let firstIndex = defines[0]._index;
        this._singleWord = true;
        for (let i = 0; i < defines.length; i++) {
            if (defines[i]._index !== firstIndex) {
                this._singleWord = false;
            }
            this._perElementDefineMap.push({ define: defines[i], bit: bits[i] });
        }
        if (this._singleWord) {
            this._sharedIndex = firstIndex;
        }
    }
    static getPerElementDefineBits(shaderData) {
        let bits = 0;
        for (let i = 0; i < this._perElementDefineMap.length; i++) {
            let entry = this._perElementDefineMap[i];
            if (shaderData.hasDefine(entry.define)) {
                bits |= entry.bit;
            }
        }
        return bits;
    }
    static __init__() {
        ShaderDefines2D.VERTEX_SIZE = Shader3D.getDefineByName("VERTEX_SIZE");
        ShaderDefines2D.FILLTEXTURE = Shader3D.getDefineByName("FILLTEXTURE");
        ShaderDefines2D.RENDERTEXTURE = Shader3D.getDefineByName('RENDERTEXTURE');
        ShaderDefines2D.MATERIALCLIP = Shader3D.getDefineByName('MATERIALCLIP');
        ShaderDefines2D.UNIFORMCLIP = Shader3D.getDefineByName('UNIFORMCLIP');
        ShaderDefines2D.UV_CLIP_GPU = Shader3D.getDefineByName('UV_CLIP_GPU');
        ShaderDefines2D.GAMMASPACE = Shader3D.getDefineByName('GAMMASPACE');
        ShaderDefines2D.INVERTY = Shader3D.getDefineByName('INVERTY');
        ShaderDefines2D.GAMMATEXTURE = Shader3D.getDefineByName('GAMMATEXTURE');
        ShaderDefines2D.TEXTURESHADER = Shader3D.getDefineByName("TEXTUREVS");
        ShaderDefines2D.PRIMITIVESHADER = Shader3D.getDefineByName("PRIMITIVEMESH");
        ShaderDefines2D.VERTEXALPHA = Shader3D.getDefineByName("VERTEXALPHA");
        ShaderDefines2D.USE_TEX_ARRAY = Shader3D.getDefineByName('USE_TEX_ARRAY');
        ShaderDefines2D.SHADERDEFINE_CAMERA2D = Shader3D.getDefineByName("CAMERA2D");
        {
            let defines = [
                ShaderDefines2D.FILLTEXTURE, ShaderDefines2D.GAMMATEXTURE, ShaderDefines2D.VERTEXALPHA,
                ShaderDefines2D.TEXTURESHADER, ShaderDefines2D.PRIMITIVESHADER, ShaderDefines2D.USE_TEX_ARRAY,
                ShaderDefines2D.MATERIALCLIP, ShaderDefines2D.UNIFORMCLIP, ShaderDefines2D.UV_CLIP_GPU,
                ShaderDefines2D.VERTEX_SIZE
            ];
            let idx0 = defines[0]._index;
            for (let i = 1; i < defines.length; i++) {
                if (defines[i]._index !== idx0) {
                    console.warn('[ShaderDefines2D] Per-element defines span multiple _index words (' + idx0 + ' vs ' + defines[i]._index + '). typeKey bit mapping uses per-define hasDefine() fallback.');
                    break;
                }
            }
        }
        ShaderDefines2D.initSprite2DCommandEncoder();
        this._buildDefineMap();
    }
    static initSprite2DCommandEncoder() {
        ShaderDefines2D.UNIFORM_NMATRIX_0 = Shader3D.propertyNameToID("u_NMatrix_0");
        ShaderDefines2D.UNIFORM_NMATRIX_1 = Shader3D.propertyNameToID("u_NMatrix_1");
        ShaderDefines2D.UNIFORM_INVERTMAT_0 = Shader3D.propertyNameToID("u_InvertMat_0");
        ShaderDefines2D.UNIFORM_INVERTMAT_1 = Shader3D.propertyNameToID("u_InvertMat_1");
        ShaderDefines2D.UNIFORM_CLIPMATDIR = Shader3D.propertyNameToID("u_clipMatDir");
        ShaderDefines2D.UNIFORM_CLIPMATPOS = Shader3D.propertyNameToID("u_clipMatPos");
        ShaderDefines2D.UNIFORM_SIZE = Shader3D.propertyNameToID("u_size");
        ShaderDefines2D.UNIFORM_VERTALPHA = Shader3D.propertyNameToID("u_VertAlpha");
        ShaderDefines2D.VIEW2D = Shader3D.propertyNameToID("u_view2D");
        ShaderDefines2D.UNIFORM_TIME = Shader3D.propertyNameToID("u_Time");
        const commandUniform = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2D");
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_NMATRIX_0, "u_NMatrix_0", ShaderDataType.Vector3);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_NMATRIX_1, "u_NMatrix_1", ShaderDataType.Vector3);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_VERTALPHA, "u_VertAlpha", ShaderDataType.Float);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_CLIPMATDIR, "u_clipMatDir", ShaderDataType.Vector4);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_CLIPMATPOS, "u_clipMatPos", ShaderDataType.Vector4);
        let passUniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DPass");
        passUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_SIZE, "u_size", ShaderDataType.Vector2);
        passUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_INVERTMAT_0, "u_InvertMat_0", ShaderDataType.Vector3);
        passUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_INVERTMAT_1, "u_InvertMat_1", ShaderDataType.Vector3);
        passUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_TIME, "u_Time", ShaderDataType.Float);
        ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATDIR = Shader3D.propertyNameToID("u_mClipMatDir");
        ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATPOS = Shader3D.propertyNameToID("u_mClipMatPos");
        ShaderDefines2D.UNIFORM_VERTEX_SIZE = Shader3D.propertyNameToID("u_vertexSize");
        ShaderDefines2D.UNIFORM_TEXRANGE = Shader3D.propertyNameToID("u_TexRange");
        ShaderDefines2D.UNIFORM_SPRITETEXTURE = Shader3D.propertyNameToID("u_spriteTexture");
        ShaderDefines2D.UNIFORM_SPRITETEXTURE_ARRAY = Shader3D.propertyNameToID("u_spriteTextureArray");
        const graphicsUniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("Sprite2DGraphics");
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATDIR, "u_mClipMatDir", ShaderDataType.Vector4);
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_MATERIAL_CLIPMATPOS, "u_mClipMatPos", ShaderDataType.Vector4);
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_VERTEX_SIZE, "u_vertexSize", ShaderDataType.Vector4);
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_TEXRANGE, "u_TexRange", ShaderDataType.Vector4);
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_SPRITETEXTURE, "u_spriteTexture", ShaderDataType.Texture2D);
        graphicsUniformMap.addShaderUniform(ShaderDefines2D.UNIFORM_SPRITETEXTURE_ARRAY, "u_spriteTextureArray", ShaderDataType.Texture2DArray);
    }
}
ShaderDefines2D.SHADER_DEFINE_BITS = 10;
ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT = 7;
ShaderDefines2D.TYPEKEY_CUSTOM_MATERIAL = 1 << 4;
ShaderDefines2D.DEFINE_BIT_FILLTEXTURE = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 0);
ShaderDefines2D.DEFINE_BIT_GAMMATEXTURE = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 1);
ShaderDefines2D.DEFINE_BIT_VERTEXALPHA = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 2);
ShaderDefines2D.DEFINE_BIT_TEXTURESHADER = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 3);
ShaderDefines2D.DEFINE_BIT_PRIMITIVESHADER = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 4);
ShaderDefines2D.DEFINE_BIT_USE_TEX_ARRAY = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 5);
ShaderDefines2D.DEFINE_BIT_MATERIALCLIP = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 6);
ShaderDefines2D.DEFINE_BIT_UNIFORMCLIP = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 7);
ShaderDefines2D.DEFINE_BIT_UV_CLIP_GPU = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 8);
ShaderDefines2D.DEFINE_BIT_VERTEX_SIZE = 1 << (ShaderDefines2D.TYPE_KEY_DEFINE_SHIFT + 9);
ShaderDefines2D._PER_ELEMENT_DEFINE_NAMES = [
    'FILLTEXTURE', 'GAMMATEXTURE', 'VERTEXALPHA', 'TEXTURESHADER',
    'PRIMITIVESHADER', 'USE_TEX_ARRAY', 'MATERIALCLIP', 'UNIFORMCLIP', 'UV_CLIP_GPU',
    'VERTEX_SIZE'
];
ShaderDefines2D._perElementDefineMap = null;
ShaderDefines2D._singleWord = false;
ShaderDefines2D._sharedIndex = -1;
